import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'rmwc/Select';
import { isNil, get } from 'lodash';

class SelectControl extends Component {
  render() {
    const { value, spec, ...other } = this.props;
    const nvalue = isNil(value) ? '' : value.toString();

    if (!spec) {
      return <Select value={nvalue} {...other} />;
    } else {
      const options = spec.options.map(opt => {
        return {
          label: get(spec, ['option_data', opt, 'label']) || opt,
          value: opt,
        };
      });
      return <Select placeholder="" options={options} value={nvalue} {...other} />;
    }
  }
}

SelectControl.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export { SelectControl };
